import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import SiteLayout from "./components/site/SiteLayout";
import Index from "./pages/Index";
import Pilot from "./pages/Pilot";
import UseCases from "./pages/UseCases";
import Consulting from "./pages/Consulting";
import About from "./pages/About";
import Start from "./pages/Start";
import StartConfirmed from "./pages/StartConfirmed";
import { Privacy, Terms } from "./pages/Legal";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

// Routes from the previous site, kept so old links and bookmarks still land somewhere useful.
const legacyRedirects: [string, string][] = [
  ["/solutions", "/pilot"],
  ["/insights", "/use-cases"],
  ["/contact", "/start"],
  ["/chat", "/start"],
  ["/careers", "/about"],
];

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Index />} />
              <Route path="/pilot" element={<Pilot />} />
              <Route path="/use-cases" element={<UseCases />} />
              <Route path="/consulting" element={<Consulting />} />
              <Route path="/about" element={<About />} />
              <Route path="/start" element={<Start />} />
              <Route path="/start/confirmed" element={<StartConfirmed />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              {legacyRedirects.map(([from, to]) => (
                <Route key={from} path={from} element={<Navigate to={to} replace />} />
              ))}
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
